import React from 'react';
import PropTypes from 'prop-types';

import {
    Container,
    Row,
    Col,
    H5,
} from '@bootstrap-styled/v4';

import ComposeReportTool from '../compose-report-tool/container';

import Style from './style';

const ComposeReport = ({
    selectproduct,
}) => (
    <Style>
        <Container>
            <Row className="mb-3">
                <Col>
                    <H5 className="text-center text-uppercase">2. Please select content sections required:</H5>
                </Col>
            </Row>
            <ComposeReportTool />
        </Container>
    </Style>

);

ComposeReport.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    selectproduct: PropTypes.object,
};

ComposeReport.defaultProps = {
    selectproduct: {},
};
export default ComposeReport;
